import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M36 36c1.65 0 3.063-.587 4.237-1.763C41.412 33.063 42 31.65 42 30s-.587-3.063-1.763-4.238C39.063 24.587 37.65 24 36 24s-3.063.587-4.238 1.762C30.587 26.938 30 28.35 30 30c0 1.65.587 3.063 1.762 4.237C32.938 35.412 34.35 36 36 36Zm0 22.05c6.1-5.6 10.625-10.688 13.575-15.262C52.525 38.212 54 34.15 54 30.6c0-5.45-1.737-9.913-5.212-13.388C45.313 13.738 41.05 12 36 12s-9.313 1.738-12.788 5.212C19.738 20.688 18 25.15 18 30.6c0 3.55 1.475 7.612 4.425 12.188C25.375 47.363 29.9 52.45 36 58.05ZM36 66c-8.05-6.85-14.063-13.212-18.038-19.087C13.988 41.038 12 35.6 12 30.6c0-7.5 2.412-13.475 7.238-17.925C24.063 8.225 29.65 6 36 6s11.938 2.225 16.763 6.675C57.588 17.125 60 23.1 60 30.6c0 5-1.987 10.438-5.962 16.313C50.063 52.788 44.05 59.15 36 66Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "marker"}) } }